import { ValueObject, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class RawGenericExportMappingSearchCriteria extends ValueObject {

    public searchCriteria: string = "";

    public staticServiceProviderFileGroupingId: number = 0;

    public staticExportFileSpecId: number = 0;
}